import { GenericDataService } from '../shared/generic-data.service';
import { Note } from './note';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceBaseService } from '../core/service-base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NoteService extends GenericDataService<Note> {
  endpointName = '/note';
  constructor(http: HttpClient, serviceBase: ServiceBaseService) {
    super(http, serviceBase);
  }

  getOne(id: string): Observable<Note> {
    // get all and filter by id
    return this.getItems().pipe(map(notes => notes.find(note => note.id === id)));
  }
}
